import { type GetHookResponse, type WithEnabled } from '../hooks'
import { recordingListKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type RecordingData, type RecordingListInput, type RecordingListSuccess } from '@terros/common'

export function useRecordings({ userId, enabled }: RecordingListInput & WithEnabled): GetHookResponse<RecordingData[]> {
  return useTantalimQuery<RecordingListInput, RecordingListSuccess, RecordingData[]>({
    url: '/recording/list',
    queryKey: recordingListKey(userId),
    input: { userId },
    convertResponse: (responseData) => {
      return responseData.recordings
    },
    options: { enabled },
  })
}
